module.exports = __webpack_public_path__ + "img/brew3.f716c2a1.png";